export const COLORS = {
  0: '#f44336',
  1: '#2196f3',
  2: '#8bc34a',
  3: '#ff9800',
  4: '#3f51b5',
  5: '#e91e63',
  6: '#03a9f4',
  7: '#ffc107',
  8: '#009688',
  9: '#ff5722',
  10: '#cddc39',
  11: '#9c27b0',
  12: '#ffeb3b',
  13: '#00bcd4',
  14: '#673ab7',
  15: '#795548',
  16: '#9e9e9e',
}
